/*!

=========================================================
* Argon Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { lazy } from "react";
// react library for routing
import { Route, Switch, Redirect } from "react-router-dom";

import { connect } from 'react-redux';

import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import _ from 'lodash'
import { DashboardRoutes, ClientMgmtRoutes } from "router/routes";
import { companyChange } from "services/http/auth";
import * as actionType from 'constants/actionType';
import * as storage from "services/utility/storage";
import InfoRefreshTokenPopup from 'views/pages/client/popup/InfoRefreshTokenPopup';

const Filter = lazy(() => import('../views/pages/filters/index'));

const Test = lazy(() => import('../views/pages/test/index'));

const AdminClient = lazy(() => import('./AdminClient'));

const ClientRedirect = lazy(() => import('../views/pages/client/redirect/clientRedirect'));

const PasswordManage = lazy(() => import('views/pages/passwordManagement'));

const ProfileManage = lazy(() => import('../views/pages/profileManage'));

let isTokenExpirInfoPopupOpened = false;

class Admin extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      sidenavOpen: true,
      leftNav: this.getChild(DashboardRoutes),
      clientTabs: this.getChild(ClientMgmtRoutes),
      refreshTokenShowPopUp: false,
    };

    const navTabs = this.getChild(ClientMgmtRoutes);
    this.props.navSet({ leftNav: [], clientTabs: navTabs });  
    this.nextLoad();
  }

  componentDidUpdate(e) {
    if (e.history.pathname !== e.location.pathname) {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.refs.mainContent.scrollTop = 0;
    }
  }

  componentWillUnmount() {
    this.cancelNextLoad();
  }

  refreshTimer = null;

  cancelNextLoad = () => {
    clearInterval(this.refreshTimer);
  };

  closeRefreshTokenPopUp = () => {
    this.setState({
      refreshTokenShowPopUp: false
    })

    isTokenExpirInfoPopupOpened = false;
  }

  nextLoad = () => {
    let interval = process.env.REACT_APP_POLLING_MINUTES * 60000;
    this.refreshTimer = setInterval(() => this.callRefreshToken(), interval);
  }

  callRefreshToken = () => { 
    if (storage.refreshTokenWithInterval() && !isTokenExpirInfoPopupOpened) {
      this.setState({
        refreshTokenShowPopUp: true
      })
      isTokenExpirInfoPopupOpened = true;
    } else {
      isTokenExpirInfoPopupOpened = false;
    }
  }

  getChild(routes, removeComponent) {
    let tmpArray = [];
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let child = this.getChild(routes[i].views)
        if (child.length > 0) {
          routes[i].views = child;
          tmpArray.push(routes[i])
        }
      } else {
        if (routes[i].leftNav || routes[i].tab) {
          if (this.checkRoleFound(routes[i].roles)) {
            if (removeComponent) {
              delete routes[i].component;
            }
            tmpArray.push(routes[i])
          }
        }
      }
    }
    return tmpArray;
  }

  getdashBoardRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getdashBoardRoutes(prop.views);
      }
      if (prop.layout === "/admin") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
            state="test"
          />
        );
      }
      else {
        return null;
      }

    }
    );
  };

  checkRoleFound = (roleList) => {
    if (roleList[0] === "any") {
      return true;
    }
    let profile = this.props.auth.profile;

    if (profile) {
      let result = _.filter(roleList, function (a) {

        return profile.role.toLowerCase() === a.toLowerCase();
      });

      if (result) {
        if (result.length > 0) {
          return true;
        }
      }
    }

    return false;
  }

  getBrandText = (path, routes) => {
    for (let i = 0; i < routes.length; i++) {
      if (
        this.props.location.pathname.indexOf(
          routes[i].layout + routes[i].path
        ) !== -1
      ) {
        return routes[i].name;
      }
    }
    return "Brand";
  };
  // toggles collapse between mini sidenav and normal
  toggleSidenav = () => {
    if (document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.remove("g-sidenav-pinned");
      document.body.classList.add("g-sidenav-hidden");
    } else {
      document.body.classList.add("g-sidenav-pinned");
      document.body.classList.remove("g-sidenav-hidden");
    }
    this.setState({
      sidenavOpen: !this.state.sidenavOpen
    });
  };

  getNavbarTheme = () => {
    return this.props.location.pathname.indexOf(
      "admin/alternative-dashboard"
    ) === -1
      ? "dark"
      : "light";
  };

  createRoutsRoutes = () => {
    const company = this.props.company;
    let ru = [];
    if (company !== null && company.companySettings) {
      let obj = company.companySettings;
      let filterList = _.uniq(_.map(obj.filter_list, 'group'), function (item) { return item; });

      _.forEach(filterList, function (value, index) {

        let routeObj = {
          collapse: true,
          name: value,
          icon: "ni ni-shop text-primary",
          state: value,
          module: "filterList",
          orderBy: 2 + index,
          views: []
        };

        let result = obj.filter_list.filter(n => n.group === value);

        _.forEach(result, function (route, index) {
          routeObj.views.push({
            path: `/filterlist/${route.id}`,
            name: route.name,
            miniName: "D",
            layout: "/admin",
            leftNav: true,
            tab: false,
            roles: ["any"],
            orderBy: index + 1
          })
        });

        ru.push(routeObj);
      });
    }
    _.forEach(this.state.leftNav, function (route) {
      ru.push(route)
    });

    return _.orderBy(ru, ['orderBy'], ['asc'])
  }

  getPathLogo = () => {
    if (this.props.company.code === "JWF") {
      return require("assets/img/brand/black.png");
    }
    else if (this.props.company.code === "LAC") {
      return require("assets/img/brand/LAC.jpg");
    }
    else {
      return require("assets/img/brand/black.png");
    }
  }

  render() {
    const routest = this.createRoutsRoutes();

    return (
      <>
        <Sidebar
          {...this.props}
          routes={routest}
          toggleSidenav={this.toggleSidenav}
          sidenavOpen={this.state.sidenavOpen}
          logo={{
            innerLink: "/admin",
            imgSrc: this.getPathLogo(),
            imgAlt: "..."
          }}
          companyCode={this.props.company.code}
          companyChange={this.props.companyChange}
        />
        <div
          className="main-content"
          ref="mainContent"
          onClick={this.closeSidenav}
        >
          <AdminNavbar
            {...this.props}
            theme={this.getNavbarTheme()}
            toggleSidenav={this.toggleSidenav}
            sidenavOpen={this.state.sidenavOpen}
            brandText="brand"
          />
          <Switch>
            {this.getdashBoardRoutes(this.state.leftNav)}
            <Route
              path={'/admin/test'}
              component={Test}
              key={'test'}
            />

            <Route
              path={'/admin/redirect/:id/:code'}
              component={ClientRedirect}
              key={'ClientRedirect'}
            />
            <Route exact path='/admin/filterlist/:id' render={(props) => (
              <Filter key={props.match.params.id} {...props} />)
            } />

            <Route
              path={'/admin/passwordmanage'}
              component={PasswordManage}
              key={'passwordmanage'}
            />

            <Route
              path={'/admin/profilemanage'}
              component={ProfileManage}
              key={'ProfileManage'}
            />

            <Route path="/admin/client" render={props => <AdminClient {...props} auth={this.props.auth} routes={this.state.clientTabs}  company = {this.props.company}/>} />;
            <Redirect from="*" to="/admin/searchLeads" />
          </Switch>
          <AdminFooter />
        </div>
        {this.state.sidenavOpen ? (
          <div className="backdrop d-xl-none" onClick={this.toggleSidenav} />
        ) : null}

        <InfoRefreshTokenPopup showPopUp={this.state.refreshTokenShowPopUp} closePopUp={this.closeRefreshTokenPopUp}></InfoRefreshTokenPopup>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    company: state.company,
    auth: state.auth,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    companyChange: (companyCode) => dispatch(companyChange(companyCode)),
    navSet: (payLoad) => dispatch({
      type: actionType.LOAD_NAVIGATION_ROUTES,
      payload: payLoad
    })
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Admin)
